import { Paper } from "@mui/material";
import { useState } from "react";
import type { InvestorCommunicationType } from "../../../../../api/types/investorCommunicationsTypes";
import { investorCommunicationTypeIcons } from "../../investorCommunicationTypeIcons";
import type { CommunicationImageSource } from "../investorCommunicationDetailsTypes";
import { getImageSourceKey } from "../investorCommunicationDetailsTypes";
import InvestorCommunicationHeroImage from "./InvestorCommunicationHeroImage";
import InvestorCommunicationHeroImageDialog from "./InvestorCommunicationHeroImageDialog";

interface Props {
  type: InvestorCommunicationType;
  source?: CommunicationImageSource;
}

const InvestorCommunicationPreviewImage = ({ type, source }: Props) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const Icon = investorCommunicationTypeIcons[type];
  const fallbackIcon = <Icon color="disabled" sx={{ width: 24, height: 24 }} />;

  return (
    <>
      <Paper
        variant="outlined"
        onClick={source ? () => setIsPreviewOpen(true) : undefined}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 168,
          height: 112,
          flexShrink: 0,
          overflow: "hidden",
          bgcolor: "background.grey",
          cursor: source ? "pointer" : undefined,
        }}
      >
        {source ? (
          <InvestorCommunicationHeroImage
            key={getImageSourceKey(source)}
            source={source}
            fallback={fallbackIcon}
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          fallbackIcon
        )}
      </Paper>

      {isPreviewOpen && source && (
        <InvestorCommunicationHeroImageDialog source={source} onClose={() => setIsPreviewOpen(false)} />
      )}
    </>
  );
};

export default InvestorCommunicationPreviewImage;
